const initState = {
    isLogging : false,
    logged : false,
    phone: null,
    token: null,
    refreshToken: null,
    loginType: -1,
    accountErrMsg: "",
    tokenErrMsg: "",
    result: {}
};

const loginReducer = (state = initState, action) => {
    switch(action.type){
        case "LOGIN":
            return{...state, isLogging: true,logged: false,accountErrMsg: "", tokenErrMsg: ""};
        case "LOGIN_SUCCESS":
            return{...state, logged: true, isLogging: false, result: action.data, 
                    accountErrMsg: "" ,tokenErrMsg: "", phone: action.phone, token: action.token, refreshToken: action.refreshToken, loginType: action.loginType
                }
        case "LOGIN_ACCOUNT_FAIL":
            return{...state,isLogging: false, accountErrMsg: action.message, tokenErrMsg: ""};
        case "LOGIN_TOKEN_FAIL":
            return{...state,isLogging: false, tokenErrMsg: action.message, accountErrMsg: ""};
        case "UPDATE_TOKEN": 
            return {...state, token: action.data.access_token, refreshToken: action.data.refresh_token}
        default:
            return state;
    }
};

export default loginReducer;